import React, {useContext, useEffect, useState} from 'react'
import ModalPopup from "../widgets/ModalPopup";
import {VasculiteForm} from "./CustomForms";
import {DefaultButton} from "../widgets/Buttons";
import DataEntryRoundsOverview from "./DataEntryRoundsOverview";
import {useApi} from "../ApiSession";


export default ({}) => {

    const [patientList, setPatientList] = useState([])

    const [newDossier, setNewDossier] = useState(null)

    const [selectedDossier, setSelectedDossier] = useState(null)

    const api = useApi()

    useEffect(() => {
        api.getMyDossiers().then(res => {
            setPatientList(res)
        })
    }, []);

    const popNewDossier = () => {
        return <ModalPopup
            title={"Créer Nouveau Dossier"}
            onClose={() => setNewDossier(null)}
        >
            <VasculiteForm
                mode={'create'}
                dossier={{}}
                showVisitDateField={true}
                onSave={newDossier => {
                    api.postNewDossier(newDossier).then(res => {
                        newDossier.id = res.id
                        newDossier.isNew = true
                        newDossier.rounds = res.rounds
                        setPatientList([...patientList, newDossier])
                        setNewDossier(null)
                    })
                }}
                onCancel={() => setNewDossier(null)}
            />
        </ModalPopup>
    }

    const popDataEntryRoundsOverview = () => {
        return <DataEntryRoundsOverview
                dossierGuid={selectedDossier.id}
                onCancel={() => setSelectedDossier(null)}
        />
    }


    const lastRound = patient => {
        return patient.rounds[patient.rounds.length -1]
    }

    return <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        {newDossier && popNewDossier()}
        {selectedDossier && popDataEntryRoundsOverview()}
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" className="px-6 py-3">
                    No Dossier
                </th>
                <th scope="col" className="px-6 py-3">
                    Sexe
                </th>
                <th scope="col" className="px-6 py-3">
                    Type de Vasculite
                </th>
                <th scope="col" className="px-6 py-3">
                    Date du Diagnostic
                </th>
                <th scope="col" className="px-6 py-3">
                    Date de visite, dernière saisie
                </th>
                <th scope="col" className="px-6 py-3">
                </th>
            </tr>
            </thead>
            <tbody>
            {
                patientList && patientList.map(p => <tr
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                    key={p.id}
                    onClick={() => setSelectedDossier(p)}
                    style={{cursor: 'pointer'}}
                >
                    <th scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                        <a>{p.id}</a>
                        {p.isNew && <span className={"ml-2 text-green-500"}>nouveau</span>}
                    </th>
                    <td className="px-6 py-4">
                        {p.gender}
                    </td>
                    <td className="px-6 py-4">
                        {p.vasculite_type}
                    </td>
                    <td className="px-6 py-4">
                        {p.diagnosis_date}
                    </td>
                    <td className="px-6 py-4">
                        {lastRound(p).visit_date}
                    </td>
                    <td className="px-6 py-4">
                        <a onClick={e => {
                            e.stopPropagation()
                            api.deleteDossier(p.id).then(res => {
                                setPatientList(patientList.filter(d => d.id !== p.id))
                            })
                        }}>supprimer</a>
                    </td>
                </tr>)
            }
            </tbody>
        </table>
        <DefaultButton
            caption={"Nouveau Dossier"}
            onClick={() => {
                setNewDossier({dossier: {}})
            }}
        />
    </div>
}



